<template>
  <div class="login-page">
    <div class="login-panel">
      <div class="login-brand">
        <div class="brand"><img :src="config.logoUrl" :alt="config.institutionName"><strong>{{ config.institutionName }}</strong></div>
        <div><h1>专业、高效、温和的<br><em>晚托管理</em>系统</h1><p>专为教育机构打造的智能化运营平台，助力每一位教育者回归教学初心。</p></div>
        <img src="/stitch-login-illustration.png" alt="晚托教育场景插图">
      </div>
      <div class="login-form">
        <h2>欢迎回来</h2><p>请输入您的管理账号以继续工作</p>
        <el-form ref="form" :model="form" :rules="rules" @submit.native.prevent="submit">
          <el-form-item prop="account" label="账号"><el-input v-model="form.account" prefix-icon="el-icon-user" placeholder="请输入手机号或账号" /></el-form-item>
          <el-form-item prop="password" label="密码"><el-input v-model="form.password" prefix-icon="el-icon-lock" show-password placeholder="请输入登录密码" /></el-form-item>
          <el-checkbox v-model="remember">记住登录状态</el-checkbox>
          <el-button class="login-submit" type="success" native-type="submit" :loading="loading">立即登录<i class="el-icon-right" /></el-button>
        </el-form>
        <div class="login-footer">© {{ config.copyrightYear }} {{ config.institutionName }}{{ config.systemName }} 版权所有</div>
      </div>
    </div>
  </div>
</template>

<script>
import config from '../../config'
export default {
  name: 'Login',
  data: () => ({ config, remember: true, loading: false, form: { account: '', password: '' }, rules: { account: [{ required: true, message: '请输入账号', trigger: 'blur' }], password: [{ required: true, message: '请输入登录密码', trigger: 'blur' }] } }),
  methods: {
    submit() {
      this.$refs.form.validate(async valid => {
        if (!valid || this.loading) return
        this.loading = true
        try {
          await this.$store.dispatch('login', { username: this.form.account, password: this.form.password, remember: this.remember })
          this.$router.replace('/dashboard')
          this.$message.success('登录成功')
        } catch (error) { this.$message.error(error.userMessage || error.message || '登录失败') } finally { this.loading = false }
      })
    }
  }
}
</script>
